import { createGlobalStyle } from 'styled-components'
import { colors, MODAL_OPENED_CN, zIndexSystem } from '@/styles/theme'
import { PBO_FORM_ROW_GAP } from '@/utils/consts'

const GlobalStyles = createGlobalStyle<{ $isWindows?: boolean }>`
  
  [data-radix-popper-content-wrapper] {
    z-index: ${zIndexSystem.modal + 10} !important;
  }
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "notokr", -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  }

  html, body {
    position: relative;
    width: 100%;
    height: 100%;
    font-size: 14px;
    line-height: 1.125;
    font-weight: 500;
    background-color: ${colors.black};
    -webkit-text-size-adjust: none;
  }

  #root {
    height: 100%;
  }
  
  a {
    color: inherit;
    
    &:visited,
    &:focus,
    &:hover {
      color: inherit;
    }
  }

  [role='button'], [role='link'] {
    cursor: pointer;
  }

  body.${MODAL_OPENED_CN} {
    overflow: hidden;
  }

  mark {
    padding: 4px 2px;
    background: ${colors.red500};
    color: ${colors.white};
  }
  
  // ICON
  [class^="ri-"], [class*=" ri-"] {
    &[data-disabled='true'] {
      cursor: not-allowed !important;
      color: ${colors.gray300} !important;
      pointer-events: none !important;
    }
  }

  [class^="ri-"]:before, [class*=" ri-"]:before {
    font-family: 'remixicon' !important;
  }

  /* 컨덕터 생성 화면(.pbo-screen-shell)과 그 모달의 폼 행 간격. 손코드 화면에는 걸리지 않는다. */
  .pbo-core-screen.pbo-screen-shell form.ant-form:not(.ant-form-inline),
  body.pbo-screen-portal .ant-modal form.ant-form:not(.ant-form-inline) {
    display: flex;
    flex-direction: column;
    gap: ${PBO_FORM_ROW_GAP}px;
  }
`

export default GlobalStyles
